import "./NavbarStyles.css";
import { MenuItems } from "./NavItems";
import {Link} from "react-router-dom";
import DropdownD from "./DropdownD";
import DropdownH from "./DropdownH";
import DropdownP from "./DropdownP";
import DropdownT from "./DropdownT";
import DropdownW from "./DropdownW";
import React, { useState } from "react";

function Navbar() {
  const [dropdownP, setDropdownP] = useState(false);
  const [dropdownD, setDropdownD] = useState(false);
  const [dropdownH, setDropdownH] = useState(false);
  const [dropdownT, setDropdownT] = useState(false);
  const [dropdownW, setDropdownW] = useState(false);

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  

  return (
    <>
      <nav className="NavbarItems">
        <Link className="Navbar-logo" to='/' onClick={closeMobileMenu}>CAR-Ma</Link>
        <div className='menu-icon' onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>
        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          {MenuItems.map((item, index) => {
            if (item.title === "Project") {
              return (
                <li
                  key={index}
                  onMouseEnter={() => setDropdownP(true)}
                  onMouseLeave={() => setDropdownP(false)}
                >

              <Link className={item.cName}>
              {item.title}  <i className='fas fa-caret-down' /> 
              </Link>
                  {dropdownP && <DropdownP />} 
                </li>
              );
            }
            if (item.title === "Wet Lab") {
              return (
                <li
                  key={index}
                  onMouseEnter={() => setDropdownW(true)}
                  onMouseLeave={() => setDropdownW(false)}
                >

              <Link className={item.cName}>
              {item.title}  <i className='fas fa-caret-down' /> 
              </Link>
                  {dropdownW && <DropdownW />}
                </li>
              );
            }
            if (item.title === "Dry Lab") {
              return (
                <li
                  key={index}
                  onMouseEnter={() => setDropdownD(true)}
                  onMouseLeave={() => setDropdownD(false)}
                >

              <Link className={item.cName}>
              {item.title}  <i className='fas fa-caret-down' /> 
              </Link>
                  {dropdownD && <DropdownD />}
                </li>
              );
            }
            if (item.title === "Human Practices") {
              return (
                <li
                  key={index}
                  onMouseEnter={() => setDropdownH(true)}
                  onMouseLeave={() => setDropdownH(false)}
                >

              <Link className={item.cName}>
              {item.title}  <i className='fas fa-caret-down' /> 
              </Link>
                  {dropdownH && <DropdownH />}
                </li>
              );
            }
            if (item.title === "Team") {
              return (
                <li
                  key={index}
                  onMouseEnter={() => setDropdownT(true)}
                  onMouseLeave={() => setDropdownT(false)}
                >

              <Link className={item.cName}>
              {item.title}  <i className='fas fa-caret-down' /> 
              </Link>
                  {dropdownT && <DropdownT />}
                </li>
              );
            }
            return (
              <li
                key={index}
              >

            <Link className={item.cName}>
            {item.title}
            </Link>
              </li>
            );
        })}
        </ul>
      </nav>
    </>
  );
}

export default Navbar;